var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSavingIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 -960 960 960",
    width: "24px",
    fill: "#1f1f1f",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M658.75-541.5q8.25-8 8.25-18.5t-8.25-18.75Q650.5-587 640-587t-18.5 8.25q-8 8.25-8 18.75t8 18.5q8 8 18.5 8t18.75-8Zm-337.25-86H519V-653H321.5v25.5Zm-101.77 454Q192-275 162.75-374.73q-29.25-99.74-29.25-205.45 0-69.27 48.56-118.05Q230.63-747 300-747h227.06q24.67-33 57.94-56.5 33.27-23.5 75-23.5 2.49 0 4.74 2.16 2.26 2.16 2.26 4.67 0 .89-.75 1.88-.75 1-.25 1.79-8.5 20.5-13.06 41.49-4.55 21-7.94 42.51L770.5-607H827v187l-103 33.93-64 212.57H533.5v-80H347v80H219.73ZM239-199h82.5v-80H559v80h82l62.19-206 98.31-33v-143.5h-41l-139-139.13q0-19.87 2.5-38.87 2.5-19 10-37.5-29.71 7.91-51.6 28.46Q560.5-748 546-721.5H300q-58.41 0-99.71 41.47Q159-638.55 159-579.88q0 98.38 27 192.05 27 93.66 53 188.83Zm241-299.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavingIcon);
export default __webpack_public_path__ + "static/media/SavingIcon.c1e9054fbcbff5c765c3bbcd55e5010f.svg";
export { ForwardRef as ReactComponent };